import { render, staticRenderFns } from "./CouponComponent.vue?vue&type=template&id=0b727aea"
import script from "./CouponComponent.vue?vue&type=script&lang=js"
export * from "./CouponComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports